export const invalidVatId = function(value, field, model, messages=null) {

    if (!value) {
        return [];
    }

    let vatId = value.replace(/\s/g,'');
    let countryToVatFormat = {
        'austria': 'ATU[0-9]{8}',
        'united kingdom': 'GB[0-9]{9}',
        'ireland': 'IE([0-9]{7}[A-Z]{1,2}|[0-9][A-Z][0-9]{5}[A-Z])',
        'france': 'FR[0-9A-Z]{2}[0-9]{9}',
        'spain': 'ES([A-Z][0-9]{8}|[A-Z][0-9]{7}[A-Z]|[0-9]{8}[A-Z])',
        'italy': 'IT[0-9]{11}|',
        'germany': 'DE[0-9]{9}',
        'netherlands': 'NL([0-9]{9}B[0-9]{2}|[0-9]{9}BO2)',
        'luxembourg': 'LU[0-9]{8}',
        'belgium': 'BE[01][0-9]{9}',
    };

    let exampleVatIds = {
        'austria': 'ATU12345678',
        'united kingdom': 'GB123456789',
        'ireland': 'IE1234567WA',
        'france': 'FR12345678901 or FRX1234567890 or FR1X123456789 or FRXX123456789',
        'spain': 'ESX12345678 or ES12345678X or ESX1234567X',
        'italy': 'IT12345678901',
        'germany': 'DE123456789',
        'netherlands': 'NL123456789B01 or NL123456789BO2',
        'luxembourg': 'LU12345678',
        'belgium': 'BE1234567890',
    };

    let country = model.country ? model.country.toLowerCase() : ""
    let capitalizedCountryCode = country
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
    if (country in countryToVatFormat) {
        if (!RegExp('^(' + countryToVatFormat[country] + ')$').test(vatId)) {
            if (!messages) {
                return [`Invalid VAT Id. The format for ${capitalizedCountryCode} is ${exampleVatIds[country]}`];
            } else {
                return [messages.invalidVatId.replace('COUNTRY', capitalizedCountryCode).replace('SAMPLE_VAT_ID', exampleVatIds[country])];
            }
        }
    }
    return [];
}
